import { IDeliveryGroup } from './groupPossibleDeliveries';

export const hasOneDeliveryTypeWithTwoOptions = (
  groupedDeliveries: IDeliveryGroup[]
): boolean =>
  groupedDeliveries.length === 1 &&
  groupedDeliveries[0] &&
  groupedDeliveries[0].deliveries.length === 2;
